import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { BottomNav } from './BottomNav';
import { UpdateBanner } from './UpdateBanner';

export function AppShell() {
  return (
    <div className="app-shell">
      <UpdateBanner />
      <Sidebar />
      <div className="app-main">
        <Topbar />
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
